import { render, staticRenderFns } from "./MultidelegationModal.vue?vue&type=template&id=5d15ae1f&"
import script from "./MultidelegationModal.vue?vue&type=script&lang=js&"
export * from "./MultidelegationModal.vue?vue&type=script&lang=js&"
import style0 from "./MultidelegationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports